module.exports = __webpack_public_path__ + "img/icon_2.03dc133a.svg";